import { Transform, Type } from "class-transformer";

export class MultipleValue {
  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  public date: Date;

  constructor(
    date: Date,
    public value: number,
    public numerator: number,
    public denominator: number,
    public corporateActionsAdjustment: number,
    public description: string,
  ) {
    this.date = date;
  }
}

export class ValuationMultiple {
  @Type(() => MultipleValue)
  series: MultipleValue[];

  constructor(
    public name: "priceToEarnings" | "earningsYield" | "enterpriseValueToEbitda" | undefined
  ) {
    this.series = [];
  }
}